import {useAttendant} from 'organization/Event/Attendants/ViewAttendant/AttendantProvider'
import EventPage from 'organization/Event/EventPage'
import {JoinButton} from 'organization/Event/Management'
import BreadcrumMenu from 'organization/theme/Breadcrum'
import React from 'react'
import {toast} from 'react-toastify'
import {routes} from 'routes/routes'
import {formatUserDate} from 'utils/lib/date'
import {useI18n} from 'i18n/I18nContext'

export const ViewAttendant = () => {
  const {t} = useI18n()
  const {attendant} = useAttendant()

  const handleJoin = async () => {
    const newTab = window.open(routes.loadingPage, '_blank')

    try {
      const url = attendant?.join_link?.join_link

      if (!url) {
        toast.warning(t('org.attendees.noJoinLink'))
        if (newTab) newTab.close()
        return
      }

      if (newTab) {
        newTab.location.href = url
      }
    } catch (error: any) {
      toast.warning(error?.message || t('org.attendees.somethingWrong'))
      if (newTab) newTab.close()
    }
  }

  return (
    <EventPage>
      <>
        <div className="row pl-30 pb-30 pr-30">
          <BreadcrumMenu title={t('org.attendees.viewTitle')} />

          <div className="col-xxl-12">
            <div className="create__event-area">
              <div className="body__card-wrapper">
                {/* create event form  */}

                <div className="create__event-main pt-25">
                  <div className="event__left-box">
                    <div className="event__meta-time">
                      <ul>
                        <li>
                          <span> {t('org.attendees.labelFirstName')} </span>
                          {attendant?.attendee.first_name}
                        </li>
                        <li>
                          <span> {t('org.attendees.labelLastName')} </span>
                          {attendant?.attendee.last_name}
                        </li>
                        <li>
                          <span> {t('org.attendees.labelEmail')} </span>
                          {attendant?.attendee.email}
                        </li>
                        <li>
                          <span> {t('org.attendees.labelPurchaseDate')} </span>
                          {attendant?.created_at
                            ? formatUserDate(attendant.created_at)
                            : t('org.attendees.labelNoInfo')}
                        </li>

                        <li>
                          <span>{t('org.attendees.labelTicketId')} </span>
                          {attendant?.id}
                        </li>
                        <li>
                          <span>{t('org.attendees.labelTicketTier')} </span>
                          {attendant?.event_ticket?.name ??
                            t('org.attendees.labelNoInfo')}
                        </li>
                        <li>
                          <span>{t('org.attendees.labelTicketPrice')} </span>
                          {attendant?.price} €
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="event__right-box">
                    <div className="row g-20">
                      <h3>{t('org.attendees.joinSectionTitle')} </h3>

                      <div className="event__input mb-15 pt-15">
                        <label className="input__field-text">
                          {t('org.attendees.joinLinkLabel')} <br />{' '}
                          <i>
                            <small>{t('org.attendees.joinHint')}</small>
                          </i>
                        </label>

                        <textarea disabled={true}>
                          {attendant?.join_link?.join_link}
                        </textarea>
                      </div>

                      <div>
                        <JoinButton
                          type="button"
                          onClick={handleJoin}
                          className={'input__btn w-100 '}
                        >
                          {t('org.attendees.joinButton')}
                        </JoinButton>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </EventPage>
  )
}
